import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DLink from '../../pieces/DLink';


export default function WhatIsLaeyerz() {

    return (
        <div>
            <DHeader>What is Laeyerz?</DHeader>
       
            <DText>
            Laeyerz is an open-source tool to build workflows and agents in Python.
                
            </DText>
            <DText>
            Developers can design their own Nodes that serve as connectors to different components like LLMs, APIs, databases etc. They can then connect them to form Workflows or Agents. These can then be run with ease. 
            </DText>

            <DText>
            For standard use cases like LLM calls, database interactions, vector store connections etc, pre-built Nodes that serve as connectors to different APIs are being added to the Node library. You can find these in the Laeyerz Node Repository on Github. (<DLink to="https://github.com/pixagan/laeyerz-nodes" target="_blank" rel="noopener noreferrer">https://github.com/pixagan/laeyerz-nodes</DLink>)
            </DText>

            <DText>
            This documentation will walk you through how to design, build and run workflows with Laeyerz in a step-by-step manner.
            </DText>

            <br />

            <DText>
            In the next section, learn how to download and install the Laeyerz library.
            </DText>
       
        </div>
    )
}